import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatHours'
})
export class FormatHoursPipe implements PipeTransform {

  constructor() { }

  transform(value: number): string {
    var num = value;
    var hours = (num / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    if (rhours > 0) {
      if (rminutes < 10) {
        return rhours + "h0" + rminutes;
      } else {
        return rhours + "h" + rminutes;
      }
    } else if (num === 0) {
      return '0 min';
    } else {
      return rminutes + " min";
    }

  }

}
